import { apiPost } from "./apiClient";
import { BASE_URL } from "../utils/axios";

/** Use with getOAuthStartUrl for the browser redirect flow. */
export const OAUTH_PROVIDER_GOOGLE = "google";

export const flipmailAuthService = {
  OAUTH_PROVIDER_GOOGLE,
  getOAuthStartUrl,
  redeemOAuthExchange,
};

/**
 * Full-page navigation URL for starting OAuth with a provider.
 * Add backend routes for new providers and branch here.
 */
function getOAuthStartUrl(provider) {
  if (provider === OAUTH_PROVIDER_GOOGLE) {
    return `${BASE_URL}/api/v1/auth/google/start/`;
  }
  throw new Error(`Unsupported OAuth provider: ${provider}`);
}

function redeemOAuthExchange(exchange) {
  return apiPost("/api/v1/auth/oauth/exchange/", { exchange });
}
